import { useState } from 'react'

import { Box, Icon, Text } from '@factorialco/deprecated-design-system'

import { useCallback } from 'modules/core/hooks/useCallback'
import i18n from 'modules/core/lib/i18n'

export const ManualInstitutionCard = ({
  onClick,
  selected,
}: {
  onClick: () => void
  selected: boolean
}) => {
  const [hover, setHover] = useState(false)

  const toggleHover = useCallback(() => {
    setHover((h) => !h)
  }, [])
  return (
    <Box
      border={{
        all: {
          color: selected ? 'grey800' : hover ? 'grey600' : 'grey400',
          width: 's1',
          style: 'solid',
        },
      }}
      borderRadius={{ all: 'abs016' }}
      gridColSpan={{
        xs: 4,
        m: 4,
        l: 4,
        xl: 4,
        xxl: 4,
        xxs: 4,
        s: 4,
      }}
      flexDirection="column"
      alignItems="center"
      justifyContent="spaceBetween"
      paddingX="s8"
      paddingY="s16"
      onClick={onClick}
      cursor="pointer"
      onMouseEnter={toggleHover}
      onMouseLeave={toggleHover}
      style={{ height: '165px' }}
    >
      <Box
        borderRadius={{ all: 'abs008' }}
        style={{ width: '52px', height: '52px' }}
        justifyContent="center"
        alignItems="center"
      >
        <Icon.Large icon="pig" color="viridian1000" />
      </Box>
      <Box
        width="full"
        textAlign="center"
        flexDirection="column"
        justifyContent="flexEnd"
        height="s48"
      >
        <Text.Normal ellipsis size="300" weight="semibold" lineClamp={2}>
          {i18n.t('banking.accounts.new_wizard.add_manually')}
        </Text.Normal>
      </Box>
    </Box>
  )
}
